<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      EditRegistrationTokenReveal(:item="item", @itemUpdated="$emit('itemUpdated')", type="edit")
      ActionButton(:action="remove") Delete

</template>

<script>
import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from '../ActionButton'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import MaggieHelper from '../../../../maggieHelper'
import CouponReveal from '../../../../pages/backoffice/CouponReveal'
import RegistrationTokenReveal from "../../../../pages/backoffice/RegistrationTokenReveal";
import EditRegistrationTokenReveal from "../../../../pages/backoffice/EditRegistrationTokenReveal.vue";

export default {
  name: 'RegistrationTokenButtons',
  components: {
    EditRegistrationTokenReveal,
    RegistrationTokenReveal, CouponReveal, PolicyReveal, ActionButton, ModalReveal},
  data() {
    return {}
  },
  created() {


  },

  methods: {
    remove() {
      return KeplerBackofficeSdk.registrationTokens.select(this.item.id).remove(() => {
        MaggieHelper.notification('', 'Token deleted')
        this.$emit('itemUpdated')
      })
    }
  },

  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// RegistrationTokenButtons.vue?122db3aa